module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-triangles-1983bd443289b0b7d89a3dc8d2d9d8de.svg";